<template>
  <div class="container-main">
    <div class="container-main-header-button">
      <v-btn depressed @click="back">
        <v-icon>mdi-chevron-left</v-icon>
      </v-btn>
      <span>Создание</span>
    </div>
    <v-form ref="formFirst">
      <div class="container-block">
        <div class="container-block-title">Содержание баннера</div>
        <div class="container-block-item">
          <v-text-field label="Заголовок" required type="text" outlined :rules="rules" counter v-model="banner.title"
            maxlength="100"></v-text-field>
        </div>
        <div class="container-block-item">
          <v-textarea outlined required no-resize :rules="rules" rows="4" label="Описание" counter
            v-model="banner.description" maxlength="1000"></v-textarea>
        </div>
      </div>
      <div class="container-block">
        <div class="container-block-title">Период отображения баннера</div>
        <div class="d-flex justify-space-between">
          <v-menu v-model="menu" :close-on-content-click="false" transition="scale-transition" offset-y min-width="auto">
            <template v-slot:activator="{ on, attrs }">
              <v-text-field v-model="newDate" outlined :rules="rules" :error-messages="validDates" readonly
                label="Начало публикации - конец публикации" v-bind="attrs" v-on="on"></v-text-field>
            </template>
            <v-date-picker locale="ru-Ru" color="var(--app-dark-blue-1)" v-model="dates" no-title range
              :min="new Date().toISOString().substr(0, 10)" first-day-of-week="1"></v-date-picker>
          </v-menu>
        </div>
      </div>

    </v-form>
    <div class="container-block">
      <div class="container-block-title">
        Вид перехода при нажатии на баннер
      </div>
      <TransitionObj :hideTypes="['null']" v-model="transition" ref="transition" buttonName />
    </div>
    <div class="container-block">
      <div class="container-block-title">Настройки баннера</div>
      <div class="d-flex" style="flex-direction: column; justify-content: center; gap: 20px;">
        <v-switch label="Отображать только на старых версиях" v-model="banner.isVisibleInNewAppVersion" hide-details
          color="var(--app-green-1)"></v-switch>
        <v-switch label="Отображать на Android" v-model="banner.isVisibleOnAndroid" hide-details
          color="var(--app-green-1)"></v-switch>
        <v-switch label="Отображать на IOS" v-model="banner.isVisibleOnIos" hide-details
          color="var(--app-green-1)"></v-switch>
      </div>
    </div>

    <div v-if="!newImage" class="container-block">
      <div class="container-block-title">Фон баннера</div>

      <v-file-input accept="image/*" outlined :rules="[
        (value) =>
          (value && value.size < 104857600) ||
          'Размер изображения не больше 100 мб',
      ]" hint="Максимальный размер изображения 100 мб" persistent-hint v-model="newImage" @change="previewImage"
        label="Прикрепить изображение"></v-file-input>
      <div class="container-block-gallery-button">
        Выбрать изображение из галереи
      </div>
    </div>

    <div></div>

    <div v-if="newImage" class="container-block" style="width: 100%">
      <div class="container-block-title">Кадрировать изображение</div>
      <v-simple-table>
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-left">Формат</th>
              <th class="text-left">Место отображенния</th>
              <th class="text-left">Для смартфонов</th>
              <th class="text-left">Для планшетов</th>
              <th class="text-right"></th>
            </tr>
          </thead>
          <tbody>
            <tr style="height: 60px">
              <td class="text-left">Баннер</td>
              <td class="text-left">Отображается на всплывающем окне</td>
              <td class="text-left">
                <v-btn v-if="!finishImageMobile" @click="openMobileImg" class="button-accept"
                  style="width: auto !important">
                  Кадрировать
                </v-btn>

                <div v-else class="d-flex">
                  <img @click="openMobileImg" class="table-img" :src="finishImageMobile" />
                  <v-btn outlined @click="openMobileImg" color="var(--app-dark-blue-1) " class="button-accept-outlined"
                    style="width: auto !important; margin-left: 10px">
                    Изменить
                  </v-btn>
                </div>
              </td>
              <td class="text-left">
                <v-btn v-if="!finishImageTablet" @click="openTabletImg" class="button-accept"
                  style="width: auto !important">
                  Кадрировать
                </v-btn>
                <div v-else class="d-flex">
                  <img @click="openTabletImg" class="table-img" :src="finishImageTablet" />
                  <v-btn outlined @click="openTabletImg" color="var(--app-dark-blue-1) " class="button-accept-outlined"
                    style="width: auto !important; margin-left: 10px">
                    Изменить
                  </v-btn>
                </div>
              </td>
              <td class="text-left">
                <v-btn icon @click="deleteImage">
                  <v-icon color="var(--app-red-1)"> mdi-delete-outline </v-icon>
                </v-btn>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
      <v-alert color="var(--app-red-1)" type="error" v-model="errImages">
        Откадрируйте изображения для всех типов устройств
      </v-alert>
      <v-divider></v-divider>

      <v-dialog width="800px" height="auto" persistent v-model="dialogMobile">
        <v-card width="800px" height="auto" class="rounded-0">
          <v-card-title class="dialog-title">
            <span class="title">Кадрирование изображения</span>
            <v-icon @click="dialogMobile = false">mdi-close</v-icon>
          </v-card-title>
          <v-card-text class="dialog-description">
            <div class="dialog-subtitle">
              <div class="dialog-subtitle-title">
                Отображение на мобильном устройстве
              </div>
              <div class="dialog-subtitle-text">
                Вы можете изменять размер изображения с помощью колесика мыши и
                двигать его.
              </div>
            </div>

            <div class="d-flex justify-space-between">
              <div style="width: 380px; height: 380px">
                <cropper v-if="imgSrc" ref="cropperMobail" :src="imgSrc" :default-size="defaultSize"
                  style="width: 450px; height: 450px" :stencil-props="{
                    handlers: {},
                    movable: false,
                    scalable: true,
                  }" :stencil-size="{ width: 343, height: 212, }"
                  image-restriction="stencil" @change="onChangeMobile" />
              </div>

              <div class="width: 380px; height: 380px;">
                <img width="343px" height="212px" v-if="resultImageMobile" style="margin-left: 30px" id="image"
                  :src="resultImageMobile" />
              </div>
            </div>
          </v-card-text>
          <v-card-actions class="dialog-buttons">
            <v-btn @click="closeMobileImg()" class="button-accept">
              Сохранить
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog width="800px" height="auto" persistent v-model="dialogTablet">
        <v-card width="800px" height="auto" class="rounded-0">
          <v-card-title class="dialog-title">
            <span class="title">Кадрирование изображения</span>
            <v-icon @click="dialogTablet = false">mdi-close</v-icon>
          </v-card-title>
          <v-card-text class="dialog-description">
            <div class="dialog-subtitle">
              <div class="dialog-subtitle-title">Отображение на планшете</div>
              <div class="dialog-subtitle-text">
                Вы можете изменять размер изображения с помощью колесика мыши и
                двигать его.
              </div>
            </div>

            <div class="">
              <div style="width: 100%; height: 200px">
                <cropper v-if="imgSrc" ref="cropperTablet" :src="imgSrc" style="width: 100%; height: 300px"
                  :default-size="defaultSize" :stencil-props="{
                    handlers: {},
                    movable: false,
                    scalable: true,
                  }" :stencil-size="{
  width: 658,
  height: 192,
}" image-restriction="stencil" @change="onChangeTablet" />
              </div>

              <div class="dialog-tablet-img">
                <img width="658px" height="192px" v-if="resultImageTablet" id="image" :src="resultImageTablet" />
              </div>
            </div>
          </v-card-text>
          <v-card-actions class="dialog-buttons">
            <v-btn @click="closeTabletImg()" class="button-accept">
              Сохранить
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>

    <v-alert color="var(--app-red-1)" type="error" v-model="errImagesMain">
      Прикрепите изображение
    </v-alert>

    <div class="container-block-footer-buttons">
      <div>
        <v-btn @click="saveBanner" style="width: auto !important" class="button-accept" :loading="sendForm">
          Сохранить
        </v-btn>
        <v-btn outlined @click="saveDraftBanner" :loading="sendForm" color="var(--app-dark-blue-1)"
          style="margin-left: 24px; width: auto !important" class="button-accept-outlined">
          Сохранить как черновик
        </v-btn>
      </div>
      <div></div>
    </div>
  </div>
</template>
<script>

import { Cropper } from "vue-advanced-cropper";
import "vue-advanced-cropper/dist/style.css";
import TransitionObj from "@/components/main/Transition";

export default {
  components: {
    Cropper,
    TransitionObj,
  },
  data: () => ({
    banner: {
      isWebView: false,
      isVisibleInNewAppVersion: false,
      isVisibleOnAndroid: false,
      isVisibleOnIos: false,
    },
    dates: [],
    newDate: null,
    errImages: false,
    errImagesMain: false,
    dialogMobile: false,
    dialogTablet: false,
    dateFormatted: null,
    menu: false,

    newImage: null,
    imgSrc: "",
    formData: new FormData(),
    rules: [(value) => !!value || "Обязательно к заполнению"],

    resultImageMobile: "",
    resultImageTablet: "",

    finishImageMobile: "",
    finishImageTablet: "",
    smartphoneImage: null,
    tabletImage: null,
    validDates: "",
    transition: {},
    sendForm: false,
  }),
  methods: {
    deleteImage() {
      this.newImage = null;
      this.imgSrc = "";
      this.resultImageMobile = "";
      this.resultImageTablet = "";
      this.finishImageMobile = "";
      this.finishImageTablet = "";
    },
    openMobileImg() {
      this.dialogMobile = true;
      this.errImages = false;
    },
    openTabletImg() {
      this.dialogTablet = true;
      this.errImages = false;
    },
    closeTabletImg() {
      this.finishImageTablet = this.resultImageTablet;
      this.dialogTablet = false;
      const { canvas } = this.$refs.cropperTablet.getResult();

      canvas.toBlob(
        (blob) => {
          this.formData.append("tabletImage", blob);
        },
        "image/webp",
        0.95
      );
      this.tabletImage = true;
    },
    closeMobileImg() {
      this.finishImageMobile = this.resultImageMobile;
      this.dialogMobile = false;

      const { canvas } = this.$refs.cropperMobail.getResult();

      canvas.toBlob(
        (blob) => {
          this.formData.append("smartphoneImage", blob);
        },
        "image/webp",
        0.95
      );
      this.smartphoneImage = true;
    },
    back() {
      this.$router.push({ name: "Banners" });
    },
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}.${month}.${year}`;
    },
    previewImage() {
      if (this.newImage) {
        this.imgSrc = URL.createObjectURL(this.newImage);
      } else {
        this.imgSrc = "";
      }
    },

    defaultSize({ imageSize }) {
      return {
        width: Math.min(imageSize.height, imageSize.width),
        height: Math.min(imageSize.height, imageSize.width),
      };
    },

    onChangeMobile({ canvas }) {
      this.resultImageMobile = canvas.toDataURL();
    },
    onChangeTablet({ canvas }) {
      this.resultImageTablet = canvas.toDataURL();
    },

    saveBanner() {
      if (this.$refs.formFirst.validate()) {
        if (this.dates.length == 2) {
          if (this.$refs.transition.validMethod()) {
            if (this.newImage) {
              if (this.smartphoneImage && this.tabletImage) {
                this.sendForm = true;
                this.errImages = false;
                let dateStart = 0;
                let dateEnd = 0;
                if (this.dates[0]) {
                  dateStart = new Date(this.dates[0]).getTime();
                }
                if (this.dates[1]) {
                  dateEnd = new Date(this.dates[1]).getTime();
                }

                this.formData.append("title", this.banner.title || "");
                this.formData.append(
                  "description",
                  this.banner.description || ""
                );
                this.formData.append("type", "pop-up");
                this.formData.append("status", "active");
                this.formData.append('isVisibleInNewAppVersion', !this.banner.isVisibleInNewAppVersion)
                this.formData.append('isVisibleOnAndroid', this.banner.isVisibleOnAndroid)
                this.formData.append('isVisibleOnIos', this.banner.isVisibleOnIos)
                if (this.transition.type && this.transition.type == "file") {
                  this.formData.append(
                    "file",
                    this.transition.file ? this.transition.file : null
                  );
                  const newTransition = { ...this.transition };
                  delete newTransition.file;
                  this.formData.append(
                    "transition",
                    JSON.stringify(newTransition)
                  );
                } else {
                  this.formData.append(
                    "transition",
                    JSON.stringify(this.transition)
                  );
                }
                if (this.dates[0]) {
                  this.formData.append("datePublishStart", dateStart);
                }
                if (this.dates[1]) {
                  this.formData.append("datePublishEnd", dateEnd);
                }

                this.formData.append("originalImage", this.newImage || null);

                this.$axios
                  .post(
                    this.$store.getters.apiAdminPanelV2 + "/banner",
                    this.formData,
                    {
                      headers: {
                        authorization: this.$store.getters.adminPanelHeaderAuth,
                      },
                    }
                  )
                  .then(() => {
                    this.sendForm = false;
                    this.$router.push({ name: "Banners" });
                  })
                  .catch((err) => {
                    this.sendForm = false;
                    this.$store.commit("errorSet", true);
                    this.$store.commit("errorTextSet", err);
                  });
              } else {
                this.errImages = true;
              }
            } else {
              this.errImagesMain = true;
            }
          }
        }
      }
    },

    saveDraftBanner() {
      this.sendForm = true;
      let dateStart = 0;
      let dateEnd = 0;
      if (this.dates[0]) {
        dateStart = new Date(this.dates[0]).getTime();
      }
      if (this.dates[1]) {
        dateEnd = new Date(this.dates[1]).getTime();
      }
      this.formData.append("title", this.banner.title || "");
      this.formData.append("description", this.banner.description || "");
      this.formData.append("type", "pop-up");
      this.formData.append("status", "draft");
      if (this.transition.type && this.transition.type == "file") {
        this.formData.append(
          "file",
          this.transition.file ? this.transition.file : null
        );
        const newTransition = { ...this.transition, file: {} };
        this.formData.append("transition", JSON.stringify(newTransition));
      } else {
        this.formData.append("transition", JSON.stringify(this.transition));
      }

      this.formData.append("datePublishStart", dateStart);
      this.formData.append("datePublishEnd", dateEnd);
      this.formData.append('isVisibleInNewAppVersion', !this.banner.isVisibleInNewAppVersion)

      this.formData.append("originalImage", this.newImage || null);

      this.$axios
        .post(this.$store.getters.apiAdminPanelV2 + "/banner", this.formData, {
          headers: {
            authorization: this.$store.getters.adminPanelHeaderAuth,
          },
        })
        .then(() => {
          this.sendForm = false;
          this.$router.push({ name: "Banners" });
        })
        .catch((err) => {
          this.sendForm = false;
          this.$store.commit("errorSet", true);
          this.$store.commit("errorTextSet", err);
        });
    },
  },
  created() { },

  watch: {
    dates() {
      const newArr = this.dates.map((item) => {
        const i = this.formatDate(item);
        return i;
      });
      this.newDate = newArr.join(" - ");
      if (this.dates.length != 2) {
        this.validDates = "Выберете две даты";
      } else {
        this.validDates = "";
      }
    },
    newImage() {
      if (this.newImage) {
        this.errImagesMain = false;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.container-main {
  box-sizing: border-box;

  padding: 40px !important;

  .container-main-header-button {
    display: flex;
    align-items: center;
    margin-bottom: 40px;

    span {
      font-size: 28px;
      font-weight: 400;
      margin-left: 16px;
    }
  }

  .container-block {
    width: 50%;
    margin-bottom: 20px;

    .container-block-title {
      font-size: 24px;
      font-weight: 600;
      margin-bottom: 16px;
    }

    .container-block-gallery-button {
      text-decoration: underline;
      color: #1064dd;
      font-size: 18px;
      font-weight: 400;
      cursor: pointer;
      padding-bottom: 20px;
    }

    .table-img {
      // width: 62px;
      height: 38px;
      object-fit: contain;
    }
  }

  .container-block-footer-buttons {
    display: flex;
    justify-content: space-between;
    width: 50%;
    margin-top: 60px;
  }
}

.dialog-tablet-img {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;

  img {
    width: 658;
    height: 192;
  }
}

.container-main-checkbox {
  border: 1px solid rgb(224, 224, 224);
  border-radius: 4px;
  padding-top: 20px;
  padding-left: 12px;
  margin-top: 0px !important;
}
</style>